export const SCROLL_MINI_TROLLEY = 'SCROLL_MINI_TROLLEY';

export function setNewMiniTrolleyPosition(position) {
  return {
    type: SCROLL_MINI_TROLLEY,
    position,
  };
}
